import { useState } from "react";

import {
  ExternalContainer,
  InternalContainer,
} from "../../../../components/Reusable/Layout";
import { AirtimePlansTable, AirtimePlanSearchFilter } from "./component";
import { CreateAirtimeModal } from "../../Modal/Airtime/CreateAirtimeModal";
import { AirtimePlan, AirtimePlansProps, EditAirTimePlan } from "./types";
import { EditAirtimeModal } from "../../Modal/Airtime/EditAirtimeModal";
import { DeleteAirtimeModal } from "../../Modal/Airtime/DeleteAirtimeModal";

const AirtimePlans: React.FC<AirtimePlansProps> = ({
  airtimePlans,
  loading,
  statusFilter,
  setStatusFilter,
  onAirtimePlanClick,
  searchTerm,
  setSearchTerm,
}) => {
  const [isCreateModalOpen, setIsCreateModalOpen] = useState(false);
  const [isDeleteModalOpen, setIsDeleteModalOpen] = useState(false);
  const [isEditModalOpen, setIsEditModalOpen] = useState(false);
  const [selectedAirtimePlan, setSelectedAirtimePlan] = useState<
    undefined | AirtimePlan
  >(undefined);
  const [airtimePlanId, setAirtimePlanId] = useState<number | null>(null);

  const onEditClick = (airtime: AirtimePlan) => {
    setSelectedAirtimePlan(airtime);
    setIsEditModalOpen(true);
  };

  const onDeleteClick = (id: number) => {
    setAirtimePlanId(id);
    setIsDeleteModalOpen(true);
  };
  return (
    <ExternalContainer>
      <div className="h-screen dark:bg-[#FFFFFF1A] w-[1030px]">
        <InternalContainer headerText="Airtime Plans">
          <div className="flex flex-col">
            <AirtimePlanSearchFilter
              onStatusFilter={setStatusFilter}
              searchTerm={searchTerm}
              onSearchChange={setSearchTerm}
              onCreateNewProduct={() => setIsCreateModalOpen(true)}
            />
            <div className="border border-[#FFFFFF1A]">
              <AirtimePlansTable
                airtimePlans={airtimePlans}
                statusFilter={statusFilter}
                onAirtimePlanClick={onAirtimePlanClick}
                onEditClick={onEditClick}
                onDeleteClick={onDeleteClick}
                loading={loading}
              />
            </div>
          </div>
        </InternalContainer>
        <CreateAirtimeModal
          isOpen={isCreateModalOpen}
          onClose={() => setIsCreateModalOpen(false)}
        />
        <EditAirtimeModal
          isOpen={isEditModalOpen && selectedAirtimePlan !== undefined}
          airtimePlan={selectedAirtimePlan as EditAirTimePlan | undefined}
          onClose={() => {
            setIsEditModalOpen(false);
            setSelectedAirtimePlan(undefined);
          }}
        />
        <DeleteAirtimeModal
          id={airtimePlanId}
          isOpen={isDeleteModalOpen && airtimePlanId !== null}
          onClose={() => {
            setIsDeleteModalOpen(false);
            setAirtimePlanId(null);
          }}
        />
      </div>
    </ExternalContainer>
  );
};

export default AirtimePlans;
